import { Component } from '@angular/core';
import { ErrorDetailsService } from '../../services/error-details.service';
import { IErrorMessages } from 'bi-interfaces';

@Component({
  selector: 'lib-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent {
  closeErrorMessages: boolean = true;
  currentError!: IErrorMessages | undefined;
  constructor(public errorDetailsService: ErrorDetailsService) {
    // this.errorDetailsService.PushErrorMessages({
    //   Title: "An Unexpected Error Occurred",
    //   Details: "[ArgumeNull_Gneric] Arguments: Debugging resource string are unavailable. Often the key and Arguments provide sufficient information to diagnose the problem",
    //   Link: "http://go.microsoft.com/fwlink/?linkid=106663&version=5.1.50918.00&file=mscorlib.dil&key=ArgumentNull_generic",
    //   Parameter: "name: value",
    //   Id: 0,
    //   Type: 0
    // });
    // this.errorDetailsService.PushErrorMessages({
    //   Title: "An Unexpected Error",
    //   Details: "[ArgumeNull_Gneric] Arguments: Debugging resource string are unavailable. Often the key and Arguments provide sufficient information to diagnose the problem",
    //   Link: "http://go.microsoft.com/fwlink/?linkid=106663&version=5.1.50918.00&file=mscorlib.dil&key=ArgumentNull_generic",
    //   Parameter: "name: value",
    //   Id: 1,
    //   Type: 0
    // });
  }

  closeAll() {
    this.closeErrorMessages = false;
    this.errorDetailsService.ErrorMessagesQueue.splice(0, this.errorDetailsService.ErrorMessagesQueue.length);
  }

  close(id: number) {
    this.closeErrorMessages = false;
    const index = this.errorDetailsService.ErrorMessagesQueue.findIndex(res => res.Id === id);
    this.errorDetailsService.ErrorMessagesQueue.splice(index, 1);
  }

  details(id: number) {
    if(this.errorDetailsService.ErrorMessagesQueue?.length){
      this.currentError = this.errorDetailsService.ErrorMessagesQueue.find(res => res.Id === id);
      this.errorDetailsService.showErrorMsg = true;
    }
  }

}
